import { useQuery } from '@tanstack/react-query';

import { AnyDocument } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { getDocumentTransitionsQueryKey } from '../../logic/getDocumentTransitionQueryKey';
import { getDocumentTransitions } from '../../requests/getDocumentTransitions';
import { DocumentParams } from '../../types/DocumentParams';

export const useDocumentTransitions = <
  DocumentType extends AnyDocument = AnyDocument,
>(
  documentParams: DocumentParams<'definition' | 'workflow'>,
  documentId: DocumentType['id'],
  enabled: boolean = true,
) => {
  const { constructGet } = useRequestConstructor();

  const queryKey = getDocumentTransitionsQueryKey<DocumentType>(
    documentId,
    documentParams,
  );

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentTransitions>>
  >({
    queryKey,
    queryFn: async () =>
      getDocumentTransitions(constructGet, documentParams, documentId),
    enabled,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'transitions'),
    ...rest,
  };
};
